import Aspecto from "pages/LandingPages/Aspecto";

export default function ContactUsPage() {
  return <Aspecto />;
}
